import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { sessionActions, positionsActions, devicesActions } from "./store";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import SignalCellularOffIcon from '@material-ui/icons/SignalCellularOff';
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MapIcon from "@material-ui/icons/Map";
import MailIcon from '@material-ui/icons/Mail';
import BarChartIcon from "@material-ui/icons/BarChart";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import PeopleIcon from "@material-ui/icons/People";
import StorageIcon from "@material-ui/icons/Storage";
import NotificationsIcon from "@material-ui/icons/Notifications";
import TimelineIcon from "@material-ui/icons/Timeline";
import PauseCircleFilledIcon from "@material-ui/icons/PauseCircleFilled";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import ReceiptIcon from '@material-ui/icons/Receipt';
import FolderIcon from "@material-ui/icons/Folder";
import DescriptionIcon from '@material-ui/icons/Description';
import t from "./common/localization";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import AcUnitIcon from "@material-ui/icons/AcUnit";
import ControlPointIcon from "@material-ui/icons/ControlPoint";
import DevicesOtherIcon from "@material-ui/icons/DevicesOther";
import DevicesIcon from "@material-ui/icons/Devices";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import BrokenImageIcon from "@material-ui/icons/BrokenImage";
import AddToQueueIcon from "@material-ui/icons/AddToQueue";
import PostAddIcon from "@material-ui/icons/PostAdd";
import Avatar from "@material-ui/core/Avatar";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import StreetviewIcon from "@material-ui/icons/Streetview";
import DeviceHubIcon from "@material-ui/icons/DeviceHub";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { InputAdornment, TextField, Typography } from "@material-ui/core";
import { RestoreOutlined, Visibility, VisibilityOff } from "@material-ui/icons";

const drawerWidth = 55;

const useStyles = makeStyles((theme) => ({
  flex: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  list: {
    width: 230,
  },
  menuButton: {
    marginLeft: -15,
    marginRight: 20,
  },
  listItemIcon: {
    marginLeft: 6,
    marginRight: 6,
    fontSize: 16, //Insert your required size
    color: "white",
  },
  listItem1: {
    paddingLeft: 20,
    paddingRight: 15,
    height: 42,
    fontSize: 16,
    color: "#6269C2",
  },
  listItem: {
    paddingLeft: 30,
    paddingRight: 15,
    "&:hover": {
      background: "#161969",
    },
  },
  listItemText: {
    marginRight: -10,
    marginLeft: -10,
    fontSize: 14, //Insert your required size
    color: "white",
  },
  avatarMini: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "#523ed2",
    margin: "-5px",
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "#1F1F51",
    margin: "5px",
  },
  listItemMini: {
    // paddingLeft: 30,
    // paddingRight: 15,
  },
  listItemIconMini: {
    // marginLeft: 10,
    fontSize: 16, //Insert your required size
    color: "white",
  },
  listItemTextMini: {
    marginRight: -20,
    marginLeft: -20,
    fontSize: 14, //Insert your required size
    color: "black",
  },
  listItemHeader: {
    marginLeft: -15,
    marginRight: 20,
  },
  divider: {
    background: "#6269C2",
  },
  subHeader: {
    color: "white",
  },
  drawer: {
    boxShadow: "-3px 10px 8px 10px #b9bcdf",
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    boxShadow: "-3px 10px 8px 10px #b9bcdf",
    width: drawerWidth,
    backgroundColor: "#361DDB",
  },
  drawerPaperNew: {
    backgroundColor: "#361DDB",
  },
}));

const MainToolbar = () => {
  const dispatch = useDispatch();
  const [drawer, setDrawer] = useState(false);
  const classes = useStyles();
  const history = useHistory();
  const [accountBalance, setAccountBalance] = useState(0);
  const userDetails = useSelector((state) => state.session.user);
  const [showPointsDialog, setPointsDialogShow] = useState(false);
  const [showChangePasswordDialog, setShowChangePasswordDialog] = useState(false);
  const [showHelpAndSupport, setShowHelpAndSupport] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [serviceProvider, setServiceProvider] = useState({});
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confPassword, setConfPassword] = useState('');
  const [showReportDialogBox, setShowReportDialogBox] = useState(false);
  const [reportType, setReportType] = useState('');

  const adminEnabled = useSelector(
    (state) => state.session.user && state.session.user.administrator
  );
  const distributorEnabled = useSelector(
    (state) => state.session.user && state.session.user.distributor
  );
  const managerEnabled = useSelector(
    (state) => state.session.user && state.session.user.userLimit != 0
  );
  const prepaidUser = useSelector(
    (state) => state.session.user && state.session.user.prepaid
  );
  const userId = useSelector(
    (state) => state.session.user && state.session.user.id
  );
  const userMaiden = useSelector(
    (state) => state.session.user && state.session.user.userMaidenPoints
  );
  const userRenewal = useSelector(
    (state) => state.session.user && state.session.user.userRevivalPoints
  );
  const deviceMaiden = useSelector(
    (state) => state.session.user && state.session.user.deviceMaidenPoints
  );
  const deviceRenewal = useSelector(
    (state) => state.session.user && state.session.user.deviceRevivalPoints
  );
  const devicePoints = useSelector(
    (state) => state.session.user && state.session.user.devicePoints
  );
  const mailId = useSelector(
    (state) => state.session.user && state.session.user.email
  );
  const getAccountBalance = async () => {    
    const response = await fetch(`/api/vendorAccount/getByUser/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    setAccountBalance(result.accountBalance);
  };
  const handleHelpAndSupport = async ()=>{
    setShowHelpAndSupport(true);
    const response = await fetch(`/api/users/${userId}/userDevicesState?pieChartOnly=true`, {
      method: 'GET',
    });

    if (response.ok) {
      const result = await response.json();
      setServiceProvider(result.serviceProvider);
      console.log(result.serviceProvider);
    } else {
      const result = await response.json();
    }
    setShowHelpAndSupport(true)
  }
  const openPointsDialog = () => {
    setPointsDialogShow(true);
  };
  const onCloseDialog = () => {
    setPointsDialogShow(false);
    setShowChangePasswordDialog(false);
    setShowHelpAndSupport(false);
    setShowReportDialogBox(false);
  }

  const openDrawer = () => {
    setDrawer(true);
  };
  const closeDrawer = () => {
    setDrawer(false);
  };

  const handleChangePassword = async () => {
    if (!oldPassword || !newPassword || !confPassword) {
      setError('Please fill out all fields.');
      return;
    }

    if (newPassword !== confPassword) {
      setError('New Password and Confirm Password do not match.');
      return;
    }

    const payload = {
      newPassword: newPassword,
      password: oldPassword,
    };

    console.log(payload);

    try {
      const response = await fetch(`/api/users/${userId}/resetOwnPassword`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        dispatch(devicesActions.refresh([]));
        dispatch(positionsActions.refresh([]));
        dispatch(sessionActions.updateUser(null));
        handleLogout();
      } else {
        const result = await response.json();
        setError(result.message || 'Failed to change password.');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
  };

  const handleMailReport = (type) =>{
    setReportType(type);
    setShowReportDialogBox(true);
  }

  const handleLogout = async () => {
    const response = await fetch("/api/session", { method: "DELETE" });
    if (response.ok) {
      dispatch(devicesActions.refresh([]));
      dispatch(positionsActions.refresh([]));
      dispatch(sessionActions.updateUser(null));
      history.push("/login");
    }
  };

  useEffect(() => {
    if((adminEnabled || distributorEnabled) && !prepaidUser){
      getAccountBalance();
    }
  
  }, []);

  return (
    <>
      {/* <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={openDrawer}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" color="inherit" className={classes.flex}>
            Gps Tracking
          </Typography>
        </Toolbar>
      </AppBar> */}

      <Drawer
        open={drawer}
        onClose={closeDrawer}
        classes={{
          paper: classes.drawerPaperNew,
        }}
      >
        <div
          tabIndex={0}
          className={classes.list}
          role="button"
          onClick={closeDrawer}
          onKeyDown={closeDrawer}
          // style={{ backgroundColor: "#050039" }}
        >
          <List>
            {/* <ListItem
              className={classes.listItem}
              button
              onClick={openDrawer}
            >
              <ListItemIcon>
                <MenuIcon className={classes.listItemIcon} />
              </ListItemIcon>
              
            </ListItem> */}
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/")}
            >
              <ListItemIcon>
                <MapIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={t("mapTitle")}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
          </List>
          <Divider className={classes.divider} />
          <List
            subheader={
              <ListSubheader className={classes.subHeader}>
                {t("reportTitle")}
              </ListSubheader>
            }
          >
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/summary")}
            >
              <ListItemIcon>
                <FormatListBulletedIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={t("reportSummary")}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/event")}
            >
              <ListItemIcon>
                <NotificationsActiveIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={t("reportEvents")}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/ignitionDuration")}
            >
              <ListItemIcon>
                <VpnKeyIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={t("reportIgnitionHours")}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/acDuration")}
            >
              <ListItemIcon>
                <AcUnitIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={t("reportACHours")}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/stop")}
            >
              <ListItemIcon>
                <PauseCircleFilledIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={t("reportStops")}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/trip")}
            >
              <ListItemIcon>
                <PlayCircleFilledIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={t("reportTrips")}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/route")}
            >
              <ListItemIcon>
                <TimelineIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={t("reportRoute")}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/offlineDuration")}
            >
              <ListItemIcon>
                <SignalCellularOffIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={"Offline Duration"}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/chart")}
            >
              <ListItemIcon>
                <TrendingUpIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={t("reportChart")}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/geofence")}
            >
              <ListItemIcon>
                <StreetviewIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={"Geofences"}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/devicesdocuments")}
            >
              <ListItemIcon>
                <DescriptionIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={"Devices Documents"}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/candata")}
            >
              <ListItemIcon>
                <DeviceHubIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={"More Details"}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>

            {(adminEnabled || managerEnabled) && prepaidUser && (
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/pointTransactions")}
              >
              <ListItemIcon>
                <ControlPointIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={t("reportPointTransactions")}
                classes={{ primary: classes.listItemText }}
                />
            </ListItem>
            )}
            {(adminEnabled || managerEnabled || distributorEnabled) && (
              <>
              <ListItem
                className={classes.listItem}
                button
                onClick={() => {handleMailReport("usersAndDevicesBasic")}}
                >
                <ListItemIcon>
                  <MailIcon className={classes.listItemIcon} />
                </ListItemIcon>
                <ListItemText
                  primary={"User & Device Report"}
                  classes={{ primary: classes.listItemText }}
                  />
              </ListItem>
              <ListItem
                className={classes.listItem}
                button
                onClick={() => {handleMailReport("deviceBaseReport")}}
                >
                <ListItemIcon>
                  <MailIcon className={classes.listItemIcon} />
                </ListItemIcon>
                <ListItemText
                  primary={"Device Report Only"}
                  classes={{ primary: classes.listItemText }}
                  />
              </ListItem>
            </>)}
            {(adminEnabled || managerEnabled) && !prepaidUser && (
              <>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/accountTransactions")}
              >
              <ListItemIcon>
                <AccountBalanceWalletIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={"Account Transactions"}
                classes={{ primary: classes.listItemText }}
                />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={() => history.push("/reports/billingTransactions")}
              >
              <ListItemIcon>
                <ReceiptIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={"Billing Transactions"}
                classes={{ primary: classes.listItemText }}
                />
            </ListItem>
            </>
            )}
            {adminEnabled && (
              <ListItem
                className={classes.listItem}
                button
                onClick={() => history.push("/reports/position")}
              >
                <ListItemIcon>
                  <TimelineIcon className={classes.listItemIcon} />
                </ListItemIcon>
                <ListItemText
                  primary={t("reportPositions")}
                  classes={{ primary: classes.listItemText }}
                />
              </ListItem>
            )}
          </List>
          <Divider className={classes.divider} />
          {/* Show Points or Credits */}
          <List
            subheader={
              <ListSubheader className={classes.subHeader}>
                {t("settingsTitle")} {(managerEnabled || distributorEnabled) && (prepaidUser ? ("/ Points: "+devicePoints) : (" / Credits: "+accountBalance))}
              </ListSubheader>
            }
          >
            {(adminEnabled || managerEnabled) && (
              <>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => history.push("/device")}
                >
                  <ListItemIcon>
                    <AddToQueueIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Create Device"}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>{" "}
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => history.push("/admin/devices")}
                >
                  <ListItemIcon>
                    <DevicesIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={"All "+t("settingsDevices")}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => history.push("/user")}
                >
                  <ListItemIcon>
                    <PersonAddIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Create User"}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => history.push("/admin/users")}
                >
                  <ListItemIcon>
                    <PeopleIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={"All "+t("settingsUsers")}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => history.push("/settings/groups")}
                >
                  <ListItemIcon>
                    <FolderIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("settingsGroups")}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>

                {prepaidUser &&
                  <ListItem
                    className={classes.listItem}
                    button
                    onClick={openPointsDialog}
                  >
                    <ListItemIcon>
                      {/* <AddToQueueIcon className={classes.listItemIcon} /> */}
                      <ControlPointIcon className={classes.listItemIcon}/>
                    </ListItemIcon>
                    <ListItemText
                      primary={"My Old Points"}
                      classes={{ primary: classes.listItemText }}
                    />
                  </ListItem>
                }
              </>
            )}

            {adminEnabled && (
              <>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => history.push("/settings/notifications")}
                >
                  <ListItemIcon>
                    <NotificationsIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("sharedNotifications")}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>

                <a href="/old_release.html" target="_blank">
                  <ListItem
                    className={classes.listItem}
                    button
                    // onClick={handleLogout}
                  >
                    <ListItemIcon>
                      {/* <ExitToAppIcon className={classes.listItemIconMini} /> */}
                      <BrokenImageIcon className={classes.listItemIcon} />
                    </ListItemIcon>
                    <ListItemText
                      primary={t("settingsOldPanel")}
                      classes={{ primary: classes.listItemText }}
                    />
                  </ListItem>
                </a>
              </>
            )}
            <ListItem
              className={classes.listItem}
              button
              onClick={handleHelpAndSupport}
            >
              <ListItemIcon>
                <HelpOutlineIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={`Help And Support`}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={(e)=>{setShowChangePasswordDialog(true)}}
            >
              <ListItemIcon>
                <VpnKeyIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={`Change Password`}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
            <ListItem
              className={classes.listItem}
              button
              onClick={handleLogout}
            >
              <ListItemIcon>
                <ExitToAppIcon className={classes.listItemIcon} />
              </ListItemIcon>
              <ListItemText
                primary={`${t("loginLogout")} (${userDetails?.username})`}
                classes={{ primary: classes.listItemText }}
              />
            </ListItem>
          </List>
          {adminEnabled && (
            <>
              <Divider className={classes.divider} />
              <List
                subheader={
                  <ListSubheader className={classes.subHeader}>
                    {t("userAdmin")}
                  </ListSubheader>
                }
              >
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => history.push("/admin/server")}
                >
                  <ListItemIcon>
                    <StorageIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("settingsServer")}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => history.push("/admin/deviceModels")}
                >
                  <ListItemIcon>
                    <DevicesOtherIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("settingsDeviceModels")}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => history.push("/admin/vendors")}
                >
                  <ListItemIcon>
                    <GroupAddIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("settingsVendors")}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => history.push("/admin/blades")}
                >
                  <ListItemIcon>
                    <PostAddIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("settingsBlades")}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>
                <ListItem
                  className={classes.listItem}
                  button
                  onClick={() => history.push("/admin/computedattributes")}
                >
                  <ListItemIcon>
                    <PostAddIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("computedAttributes")}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>
                <ListItem className={classes.listItem} button disabled>
                  <ListItemIcon>
                    <BarChartIcon className={classes.listItemIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("statisticsTitle")}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>
              </List>
            </>
          )}
        </div>
      </Drawer>

      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
      >
        <div style={{ backgroundColor: "#371dda" }}>
          <List>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={openDrawer}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <MenuIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <MapIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
          </List>
          <Divider className={classes.divider} />
          <List>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/summary")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <FormatListBulletedIcon
                    className={classes.listItemIconMini}
                  />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/event")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <NotificationsActiveIcon
                    className={classes.listItemIconMini}
                  />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/ignitionDuration")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <VpnKeyIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/acDuration")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <AcUnitIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/stop")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <PauseCircleFilledIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/trip")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <PlayCircleFilledIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/route")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <TimelineIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/offlineDuration")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <SignalCellularOffIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/chart")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <TrendingUpIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/geofence")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <StreetviewIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/devicesdocuments")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <DescriptionIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={() => history.push("/reports/candata")}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <DeviceHubIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            {(adminEnabled || managerEnabled) && prepaidUser && (
              <ListItem
                className={classes.listItemMini}
                button
                onClick={() => history.push("/reports/pointTransactions")}
                >
                <ListItemIcon>
                  <Avatar className={classes.avatarMini}>
                    <ControlPointIcon className={classes.listItemIconMini} />
                  </Avatar>
                </ListItemIcon>
              </ListItem>
            )}
            {(adminEnabled || managerEnabled || distributorEnabled) && (
            <>
              <ListItem
                className={classes.listItemMini}
                button
                onClick={()=>{handleMailReport("usersAndDevicesBasic")}}
                >
                <ListItemIcon>
                  <Avatar className={classes.avatarMini}>
                    <MailIcon className={classes.listItemIconMini} />
                  </Avatar>
                </ListItemIcon>
              </ListItem>
              <ListItem
                className={classes.listItemMini}
                button
                onClick={()=>{handleMailReport("deviceBaseReport")}}
                >
                <ListItemIcon>
                  <Avatar className={classes.avatarMini}>
                    <MailIcon className={classes.listItemIconMini} />
                  </Avatar>
                </ListItemIcon>
              </ListItem>
              </>
            )}
            {(adminEnabled || managerEnabled) && !prepaidUser && (<>
              <ListItem
                className={classes.listItemMini}
                button
                onClick={() => history.push("/reports/accountTransactions")}
                >
                <ListItemIcon>
                  <Avatar className={classes.avatarMini}>
                    <AccountBalanceWalletIcon className={classes.listItemIconMini} />
                  </Avatar>
                </ListItemIcon>
              </ListItem>
              <ListItem
                className={classes.listItemMini}
                button
                onClick={() => history.push("/reports/billingTransactions")}
                >
                <ListItemIcon>
                  <Avatar className={classes.avatarMini}>
                    <ReceiptIcon className={classes.listItemIconMini} />
                  </Avatar>
                </ListItemIcon>
              </ListItem>
            </>
            )}
            {adminEnabled && (
              <ListItem
                className={classes.listItemMini}
                button
                onClick={() => history.push("/reports/position")}
              >
                <ListItemIcon>
                  <Avatar className={classes.avatarMini}>
                    <TimelineIcon className={classes.listItemIconMini} />
                  </Avatar>
                </ListItemIcon>
              </ListItem>
            )}
          </List>
          <Divider className={classes.divider} />
          <List>
            {(adminEnabled || managerEnabled) && (
              <>
                <ListItem
                  className={classes.listItemMini}
                  button
                  onClick={() => history.push("/device")}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <AddToQueueIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>{" "}
                <ListItem
                  className={classes.listItemMini}
                  button
                  onClick={() => history.push("/admin/devices")}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <DevicesIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>
                <ListItem
                  className={classes.listItemMini}
                  button
                  onClick={() => history.push("/user")}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <PersonAddIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>
                <ListItem
                  className={classes.listItemMini}
                  button
                  onClick={() => history.push("/admin/users")}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <PeopleIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>
                <ListItem
                  className={classes.listItemMini}
                  button
                  onClick={() => history.push("/settings/groups")}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <FolderIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>

                {prepaidUser &&
                  <ListItem
                    className={classes.listItemMini}
                    button
                    onClick={openPointsDialog}
                  >
                    <ListItemIcon>
                      <Avatar className={classes.avatarMini}>
                        <ControlPointIcon className={classes.listItemIconMini} />
                      </Avatar>
                    </ListItemIcon>
                  </ListItem>
                }
              </>
            )}

            {adminEnabled && (
              <>
                <ListItem
                  className={classes.listItemMini}
                  button
                  onClick={() => history.push("/settings/notifications")}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <NotificationsIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>
                <ListItem
                  className={classes.listItemMini}
                  button
                  // onClick={handleLogout}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      {/* <ExitToAppIcon className={classes.listItemIconMini} /> */}
                      <a href="/old_release.html" target="_blank">
                        <BrokenImageIcon className={classes.listItemIconMini} />
                      </a>
                    </Avatar>
                  </ListItemIcon>
                </ListItem>
              </>
            )}
            <ListItem
              className={classes.listItemMini}
              button
              onClick={handleHelpAndSupport}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <HelpOutlineIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={(e)=>{setShowChangePasswordDialog(true)}}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <VpnKeyIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
            <ListItem
              className={classes.listItemMini}
              button
              onClick={handleLogout}
            >
              <ListItemIcon>
                <Avatar className={classes.avatarMini}>
                  <ExitToAppIcon className={classes.listItemIconMini} />
                </Avatar>
              </ListItemIcon>
            </ListItem>
          </List>
          {adminEnabled && (
            <>
              <Divider className={classes.divider} />
              <List>
                <ListItem
                  className={classes.listItemMini}
                  button
                  onClick={() => history.push("/admin/server")}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <StorageIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>
                <ListItem
                  className={classes.listItemMini}
                  button
                  onClick={() => history.push("/admin/deviceModels")}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <DevicesOtherIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>
                <ListItem
                  className={classes.listItemMini}
                  button
                  onClick={() => history.push("/admin/vendors")}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <GroupAddIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>
                <ListItem
                  className={classes.listItemMini}
                  button
                  onClick={() => history.push("/admin/blades")}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <PostAddIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>
                <ListItem
                  className={classes.listItemMini}
                  button
                  onClick={() => history.push("/admin/computedattributes")}
                >
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <PostAddIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>
                <ListItem className={classes.listItemMini} button disabled>
                  <ListItemIcon>
                    <Avatar className={classes.avatarMini}>
                      <BarChartIcon className={classes.listItemIconMini} />
                    </Avatar>
                  </ListItemIcon>
                </ListItem>
              </List>
            </>
          )}
        </div>
      </Drawer>
      <Dialog
        open={showPointsDialog}
        onClose={onCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"My Old Points"}
        </DialogTitle>
        <DialogContent>
          <List>
            <ListItem>
              <ListItemText primary="User Maiden points" style={{textAlign: "center"}} />
            </ListItem>
            <ListItem>
              <ListItemText primary={userMaiden} style={{textAlign: "center"}} />
            </ListItem>

            <ListItem>
              <ListItemText primary="Device Maiden points" style={{textAlign: "center"}} />
            </ListItem>
            <ListItem>
              <ListItemText primary={deviceMaiden} style={{textAlign: "center"}} />
            </ListItem>

            <ListItem>
              <ListItemText primary="User Renewal points" style={{textAlign: "center"}} />
            </ListItem>
            <ListItem>
              <ListItemText primary={userRenewal} style={{textAlign: "center"}} />
            </ListItem>

            <ListItem>
              <ListItemText primary="Device Renewal points" style={{textAlign: "center"}} />
            </ListItem>
            <ListItem>
              <ListItemText primary={deviceRenewal} style={{textAlign: "center"}} />
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseDialog} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showChangePasswordDialog}
        onClose={onCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Change Password"}
        </DialogTitle>
        <DialogContent>
          <form autoComplete="off">
            <TextField
              margin="dense"
              id="oldPassword"
              label="Old Password"
              onChange={(e)=>{setOldPassword(e.target.value)}}
              value={oldPassword}
              type={showPassword ? 'text' : 'password'}
              fullWidth
              variant="filled"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              margin="dense"
              id="newPassword"
              label="New Password"
              onChange={(e)=>{setNewPassword(e.target.value)}}
              value={newPassword}
              type={showPassword ? 'text' : 'password'}
              fullWidth
              variant="filled"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              margin="dense"
              id="confirmPassword"
              label="Confirm Password"
              onChange={(e)=>{setConfPassword(e.target.value)}}
              value={confPassword}
              type={showPassword ? 'text' : 'password'}
              fullWidth
              variant="filled"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseDialog}>Cancel</Button>
          <Button onClick={() => handleChangePassword()} autoFocus>
            Change Password
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showHelpAndSupport}
        onClose={onCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          className: "p-6 rounded-2xl shadow-lg max-w-2xl w-full" // increased width
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          className="border-b pb-2 mb-4"
        >
          <div className="flex justify-center">
            <Typography 
              className={classes.heading}
              style={{ fontWeight: 500, fontSize: 30 }}
            >
              {serviceProvider.name && serviceProvider.name}
            </Typography>
          </div>
        </DialogTitle>

        <DialogContent dividers className="space-y-4 text-base text-gray-700">
          {serviceProvider.name && (
            <div>
              <strong className="text-gray-900">Company Name:</strong> {serviceProvider.name}
            </div>
          )}
          {serviceProvider.helpline && (
            <div>
              <strong className="text-gray-900">HelpLine:</strong> {serviceProvider.helpline}
            </div>
          )}
          {serviceProvider.email && (
            <div>
              <strong className="text-gray-900">Email:</strong> {serviceProvider.email}
            </div>
          )}
          {serviceProvider.address && (
            <div>
              <strong className="text-gray-900">Address:</strong> {serviceProvider.address}
            </div>
          )}
          {serviceProvider.contactPerson && (
            <div>
              <strong className="text-gray-900">Contact Person:</strong> {serviceProvider.contactPerson}
            </div>
          )}
          {serviceProvider.website && (
            <div>
              <strong className="text-gray-900">Website:</strong> {serviceProvider.website}
            </div>
          )}
          {serviceProvider.tagline && (
            <div>
              <strong className="text-gray-900">Tag Line:</strong> {serviceProvider.tagline}
            </div>
          )}
        </DialogContent>

        <DialogActions className="pt-4">
          <Button onClick={onCloseDialog} className="font-semibold text-base">
            Close
          </Button>
          {serviceProvider.website && (
            <Button
              autoFocus
              href={"http://" + serviceProvider.website}
              className="bg-blue-600 text-white font-semibold text-base px-4 py-2 rounded-md hover:bg-blue-700"
            >
              Visit Website
            </Button>
          )}
        </DialogActions>
      </Dialog>
        
      <Dialog
        open={showReportDialogBox}
        onClose={onCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          className: "p-6 rounded-2xl shadow-lg max-w-2xl w-full" // increased width
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          className="border-b pb-2 mb-4"
        >
          <div className="flex justify-center">
            <Typography 
              className={classes.heading}
              style={{ fontWeight: 500, fontSize: 25 }}
            >
              Confirm Mail ID?
            </Typography>
          </div>
        </DialogTitle>

        <DialogContent dividers className="space-y-4 text-base text-gray-700">
          Mail ID:
          {" "}
          {mailId}
          <br/>
          {"(If its wrong then contact your service provider)"}
        </DialogContent>

        <DialogActions className="pt-4">
          <Button onClick={onCloseDialog} className="font-semibold text-base">
            Close
          </Button>
          <Button onClick={async () => {
            const response = await fetch(`/api/reports/${reportType}?userId=${userId}&mail=true&all=true`, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            });
            setShowReportDialogBox(false);
            alert("Mail Sent Successfully. Check Your Mail After Sometime.");
          }} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

export default MainToolbar;
